import { render } from "./PCard.vue?vue&type=template&id=417d8031"
import script from "./PCard.vue?vue&type=script&lang=js"
export * from "./PCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__